import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { IUserData } from '@resident-nx/shared';
import { AsyncPipe } from '@angular/common';
import { AvatarSizeEnum, AvatarWebComponent } from '@resident-nx/web/ui';
import { LogoComponent } from '../../atoms/logo/logo.component';
import { ElevationDirective } from '@resident-nx/web/ui';
import { ImmomioIconButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ElevationDirective,
    ImmomioIconButtonComponent,
    LogoComponent,
    AvatarWebComponent,
    AsyncPipe,
  ],
})
export class HeaderComponent {
  @Input() userData$: Observable<IUserData>;
  @Input() navigationOpen: boolean;
  @Input() profileSettingsOpen: boolean;
  @Output() navigationToggleClick = new EventEmitter<Event>();
  @Output() profileSettingsToggleClick = new EventEmitter<Event>();
  public avatarSize = AvatarSizeEnum;

  public onNavigationToggleClick(event: Event) {
    this.navigationToggleClick.emit(event);
  }

  public onProfileSettingsToggleClick(event: Event) {
    this.profileSettingsToggleClick.emit(event);
  }
}
